import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Filter from '../../../Filter/Filter'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import API from '../../../../api/api'
import { updateProviderLocation } from '../../../../reducers/reputationManagementReducer'

const Locations = ({
  buildingId,
  onBack = () => {},
  onClose = () => {},
  updateProviderLocation = () => {},
  onConnected = () => {},
}) => {
  const { t } = useTranslation(['organisation', 'common'])
  const [locations, setLocations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { displaySnackbar } = useSnackbar()

  const fetchLocations = async () => {
    try {
      const { data } = await API.getProviderLocationsList(buildingId, 'google')
      setLocations(
        data.map((location) => ({
          id: location.id,
          text: location.name,
          value: location.id,
        })),
      )
    } catch (error) {
      console.error(error)
      displaySnackbar(t('organisation:reputationManagement.locations.errors.fetchFailed'), true)
    }
  }
  const handleConnect = async () => {
    try {
      setIsLoading(true)
      await updateProviderLocation(buildingId, 'google', selectedLocation.id, selectedLocation.text)
      displaySnackbar(t('organisation:reputationManagement.locations.toasts.connected'), false)
      onConnected()
      onClose()
    } catch (error) {
      console.error(error)
      displaySnackbar(t('organisation:reputationManagement.locations.errors.connectFailed'), true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (buildingId) {
      fetchLocations()
    }
  }, [buildingId])

  return (
    <React.Fragment>
      <div className="reputation-management-page__settings--info">
        {t('organisation:reputationManagement.locations.almostDone')}
      </div>
      <div className="reputation-management-page__settings--location">
        <h4>{t('organisation:reputationManagement.locations.selectYourBusinessLocation')}</h4>
        <p>{t('organisation:reputationManagement.locations.businessListDescription')}</p>
        <Filter
          placeholder={
            selectedLocation
              ? selectedLocation.text
              : t('organisation:reputationManagement.locations.selectLocationPlaceholder')
          }
          options={locations}
          value={selectedLocation ? [selectedLocation] : []}
          name="location"
          additionalClass="field"
          onChange={(e) => setSelectedLocation(e.target.value)}
          closeAfterSelect
        />
      </div>
      <div className="reputation-management-page__settings--buttons">
        <button onClick={onBack} className="button button-gray">
          {t('common:actions.back')}
        </button>
        <button
          onClick={handleConnect}
          className={`button button-black ${isLoading ? 'is-loading' : ''}`}
          disabled={!selectedLocation || isLoading}
        >
          {t('organisation:reputationManagement.apartmentsConnectionModal.connect')}
        </button>
      </div>
    </React.Fragment>
  )
}

Locations.propTypes = {
  buildingId: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  updateProviderLocation: PropTypes.func.isRequired,
  onConnected: PropTypes.func.isRequired,
}

export default connect(null, { updateProviderLocation })(Locations)
